import React, { useState, useEffect, useMemo } from 'react'
import { GRAPH_COLOR_PALLET_V2_TEXT, GRAPH_COLOR_PALLET_V2 } from '../../../../constants'
import { BarContainer, LhsWrap, ListItemTextWrap, ListValue, ListWrapper, RhsWrap } from './style'
import PieAndDonutChart from '../../../../components/d3PieAndDonut/d3Pie'

const RelativeBrands = ({ graphPieData, containerWidth, showLegendToolTip = false , activeTab , maxValue, id, titleOrderedArrayFunc, sortedPieColorObject }) => {
  const [angleBuckets, setAngleBuckets] = useState(null);
  // const colors =  isExtraColor ? Object.values(LEGEND_COLOR_MAP_NEW) : LEGEND_COLOR_MAP_NEW;
  const colors = [...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT, ...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]
  const textColors = [...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT, ...GRAPH_COLOR_PALLET_V2, ...GRAPH_COLOR_PALLET_V2_TEXT]

  // const winHeight = window.innerHeight - 100
  const winWidth = document.getElementById(id)?.offsetWidth / 2 || 400;

  const pieSettings = {
    width: winWidth,
    height: 550,
    innerRadius: 24,
    outerRadius: 110, 
    textShow: true,
    textLocation: 1.4,
    color : colors,
    textColors: textColors,
    textSize: '13px',
    colors: colors,
    effects: 'InnerCircle',
    fontWeight: 400,
  }

  const halfPieSettings = {
    // width: winWidth,
    width: 350,
    height: 550,
    innerRadius: 130,
    outerRadius: 150,
    textShow: true,
    textLocation: 1.4,
    color: colors,
    textColors: textColors,
    textSize: '13px',
    colors: colors,
    effects: 'InnerCircle',
    fontWeight: 400,
  }

  const angleBucketsObj =  {
  }

  useEffect(() => {
    setAngleBuckets(angleBucketsObj)
  }, [graphPieData])

  useEffect(() => {
  if (maxValue === 0) {
    console.error('🚨 RelativeBrands: maxValue is 0', {
      maxValue,
      graphPieData,
      id,
      activeTab,
    });
  }
}, [maxValue, graphPieData, id, activeTab]);

  return (
    <>
    {activeTab.includes('graph') && (
      <LhsWrap className={`${graphPieData.filter(f => (f?.name && f?.value))?.length > 13 ? 'multi-pie-data' : ''}`}>
        <PieAndDonutChart id={id} containerWidth={containerWidth} data={graphPieData.filter(f => (f?.name && f?.value))} angleBuckets={angleBuckets} halfPieSettings={halfPieSettings} settings={pieSettings} showLegendToolTip={showLegendToolTip} breakPieDataNumber={8} titleOrderedArrayFunc={titleOrderedArrayFunc} sortedPieColorObject={sortedPieColorObject} />
      </LhsWrap>
    )}

    {activeTab.includes('table') && (
      <RhsWrap>
      {graphPieData.filter(f => (f?.name && f?.value)).sort((a, b) => b.value - a.value).map((leg, i) => {
        if (leg.name === 'REMAINING_VALUE') return null;
        const heightPercent = (leg.value / maxValue) * 100;
        return (
          <ListWrapper key={leg.name + i}>
            <BarContainer barcolor={colors[i]}>
              <span className='bar-fill' style={{ height: `${heightPercent}%`, backgroundColor: colors[i] }}></span>
            </BarContainer>
            <ListItemTextWrap className={leg.value === 0 ? 'hide' : ''} key={i}>
              <span className='name'>{leg.name}</span>
              <ListValue color={textColors[i]}>{leg.value}%</ListValue>
            </ListItemTextWrap>
          </ListWrapper>
          )
        })}
        </RhsWrap>
      )}
    </>
  )
}

export default RelativeBrands
